import { PropertyRelatedRecordType, PropertyType, ProperyVisibilityType } from '@utils/constants'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { STATUS } from '@features/General'
import { ISagaCb } from '@typings/requestPayloads'

export interface ICreatePropertyPayload extends ISagaCb {
    data: {
        relatedRecordType: keyof typeof PropertyRelatedRecordType
        visibility: keyof typeof ProperyVisibilityType
        type: keyof typeof PropertyType
        relatedRecordId: string
        subRecordId?: string
        content: string
        ownerCompany?: string
        ownerUser?: string
        fileName?: string
    }
}

export interface ICreatePropertyState {
    status: string
    data: any
    errors: any
}

const initialState: ICreatePropertyState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createProperty = createSlice({
    name: 'property/create',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreatePropertyPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createPropertyActions = createProperty.actions
export default createProperty.reducer
